import {
  createChartDisplaySettings,
  createChartState,
  createDrawingState,
  createIndicatorState,
  createMarketSelection,
  createTradeState,
} from "./state";
import type {
  ChartDisplaySettings,
  DrawingState,
  IndicatorState,
  MarketSelection,
  State,
  TradeState,
} from "./types";

export type ChartModel = {
  state: State;
  displaySettings: ChartDisplaySettings;
  marketSelection: MarketSelection;
  indicatorState: IndicatorState;
  drawingState: DrawingState;
  tradeState: TradeState;
};

export type ChartModelOptions = {
  width: number;
  height: number;
  symbol?: string;
};

export function createChartModel(options: ChartModelOptions): ChartModel {
  const state = createChartState(options.width, options.height);
  const displaySettings = createChartDisplaySettings();
  const marketSelection = createMarketSelection(options.symbol);
  const indicatorState = createIndicatorState();
  const drawingState = createDrawingState();
  const tradeState = createTradeState();

  state.displaySettings = displaySettings;
  return {
    state,
    displaySettings,
    marketSelection,
    indicatorState,
    drawingState,
    tradeState,
  };
}
